import { analytics, PlanPaywallEvents } from '@/lib/analytics'

interface PlanPaywallEventData {
  userRole: 'Administrator' | 'User'
  isManaged: boolean
  currentPlan: string
  pagePath: string
  // True when the paywall is shown to a former paying customer (the reactivate
  // variant), so the reactivation funnel is measurable separately from new
  // prospects converting.
  isFormerPaidSubscriber: boolean
}

function trackEvent(event: string, data: PlanPaywallEventData): void {
  analytics.track(event, {
    user_role: data.userRole,
    is_managed: data.isManaged,
    current_plan: data.currentPlan,
    page_path: data.pagePath,
    is_former_paid_subscriber: data.isFormerPaidSubscriber,
  })
}

export function trackPlanPaywallOpened(data: PlanPaywallEventData): void {
  trackEvent(PlanPaywallEvents.OPENED, data)
}

export function trackPlanPaywallConverted(data: PlanPaywallEventData): void {
  trackEvent(PlanPaywallEvents.CONVERTED, data)
}

export function trackPlanPaywallLogoutClicked(
  data: PlanPaywallEventData,
): void {
  trackEvent(PlanPaywallEvents.LOGOUT_CLICKED, data)
}

export function trackPlanPaywallHomeClicked(data: PlanPaywallEventData): void {
  trackEvent(PlanPaywallEvents.HOME_CLICKED, data)
}
